import React from 'react';
import { useNavigate } from 'react-router-dom';

const services = [
    {
        id: 1,
        header: 'CONSULTANCY',
        content: 'We understand that every foodservice establishment is unique differently from others.',
        image: '/assets/northern_consuting.jpg'
    },
    {
        id: 2,
        header: 'PROJECT MANAGEMENT',
        content: 'Project Management is the anchor to a successful commercial kitchen project.',
        image: '/assets/northern_project_management.jpg'
    },
    {
        id: 3,
        header: 'FOOD SERVICE FACILITY DESIGN',
        content: 'We Providing an independent and unbiased design that works best for your businesses needs.',
        image: '/assets/northern_design.jpg'
    },
    {
        id: 4,
        header: 'EQUIPMENT SUPPLY & INSTALLATION',
        content: 'Choosing the correct commercial kitchen equipment is a crucial stage in your kitchen project.',
        image: '/assets/northern_installation.jpg'
    },
    {
        id: 5,
        header: 'STAINLESS STEEL FABRICATION',
        content: 'Commercial Kitchen fabrication to meet the demands of the kitchen industry.',
        image: '/assets/northern_fabrication.jpg'
    },
    {
        id: 6,
        header: 'AFTER SALES SERVICE & MAINTENANCE',
        content: 'We offers our customers with expert restaurant equipment repair and maintenance service.',
        image: '/assets/northern_service.jpg'
    }
];

export default function NewServices() {
    const navigate = useNavigate();
    return (
        <div className="bg-white min-h-screen py-12 px-4 sm:px-6 lg:px-12">
            <div className="max-w-7xl mx-auto">
                <h1 className="text-4xl font-bold text-center text-indigo-900 mb-12">Our Services</h1>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
                    {services.map((service, index) => (
                        <div
                            key={index}
                            className="bg-white cursor-pointer rounded-lg shadow-lg overflow-hidden transform transition duration-300 hover:scale-105"
                        >
                            <img
                                src={service.image}
                                alt={service.header}
                                className="w-full h-48 object-cover"
                            />
                            <div className="p-6">
                                <h2 className="text-xl font-semibold text-indigo-900 mb-3">{service.header}</h2>
                                <p className="text-gray-600 text-sm leading-relaxed">{service.content}</p>
                                <button
                                    class="bg-white mt-4 text-center w-48 rounded-2xl h-10 relative text-black text-xl font-semibold group"
                                    type="button"
                                    onClick={() => navigate(`/services/${service.id}`)}
                                >
                                    <div
                                        class="bg-indigo-900 rounded-md h-8 w-1/4 flex items-center justify-center absolute left-1 top-[4px] group-hover:w-[184px] z-10 duration-500"
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-arrow-right"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M5 12l14 0" /><path d="M13 18l6 -6" /><path d="M13 6l6 6" /></svg>
                                    </div>
                                    <p class="translate-x-2 ms-10 text-indigo-900 font-medium">Learn More </p>
                                </button>

                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}